module.exports = __webpack_public_path__ + "img/kz.f6d058d3.svg";